import { render, staticRenderFns } from "./AsyncWorldMap.vue?vue&type=template&id=2c8d0bb1&"
import script from "./AsyncWorldMap.vue?vue&type=script&lang=js&"
export * from "./AsyncWorldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8d0bb1')) {
      api.createRecord('2c8d0bb1', component.options)
    } else {
      api.reload('2c8d0bb1', component.options)
    }
    module.hot.accept("./AsyncWorldMap.vue?vue&type=template&id=2c8d0bb1&", function () {
      api.rerender('2c8d0bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorldMap/AsyncWorldMap.vue"
export default component.exports